import React from 'react';
import { Switch } from 'react-router-dom';

import PrivateRoute from './components/application/PrivateRoute';
import PublicRoute from './components/application/PublicRoute';

import Authentication from './pages/Authentication';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Register from './pages/Register';
import Prescription from './pages/Prescription';
import Search from './pages/Search';

const Routes: React.FC = () => {

  return (
    <Switch>
      <PrivateRoute exact path="/" component={Search} />
      <PublicRoute exact path="/login" component={Authentication} />
      <PublicRoute exact path="/register" component={Register} />
      <PublicRoute exact path="/forgot-password" component={ForgotPassword} />
      <PublicRoute exact path="/reset-password" component={ResetPassword} />
      <PrivateRoute exact path="/:token" component={Prescription} />
    </Switch>
  );
};

export default Routes;
